import BlogListing from "./BlogListing";

export default BlogListing;
